import { MatDateFormats } from '@angular/material/core';

export const CUSTOM_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: 'DD/MM/YYYY' // Formato in cui l'utente può inserire la data
  },
  display: {
    dateInput: 'DD/MM/YYYY', // Formato visualizzato nell'input
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'DD MMMM YYYY',
    monthYearA11yLabel: 'MMMM YYYY'
  }
};